import { useSyncExternalStore } from 'react';

type Appearance = 'light' | 'dark';
export const APPEARANCE_KEY = 'fanbird.appearance';
const changeEvent = 'fanbird:appearance';

function readPreference(): Appearance {
  try {
    const saved = localStorage.getItem(APPEARANCE_KEY);
    return saved === 'light' ? 'light' : 'dark';
  } catch { return 'dark'; }
}

export function initializeAppearance() {
  const appearance = readPreference();
  if (document.documentElement.dataset.appearance === appearance) return;
  document.documentElement.dataset.appearance = appearance;
  window.dispatchEvent(new Event(changeEvent));
}

export function setAppearance(appearance: Appearance) {
  document.documentElement.dataset.appearance = appearance;
  try { localStorage.setItem(APPEARANCE_KEY, appearance); } catch { /* Keep the current choice when storage is unavailable. */ }
  window.dispatchEvent(new Event(changeEvent));
}

function subscribe(onChange: () => void) {
  const onStorage = (event: StorageEvent) => {
    if (event.key !== APPEARANCE_KEY && event.key !== null) return;
    initializeAppearance();
    onChange();
  };
  window.addEventListener(changeEvent, onChange);
  window.addEventListener('storage', onStorage);
  return () => {
    window.removeEventListener(changeEvent, onChange);
    window.removeEventListener('storage', onStorage);
  };
}

export function useAppearance() {
  const appearance = useSyncExternalStore(subscribe, () =>
    document.documentElement.dataset.appearance === 'light' ? 'light' : 'dark');
  return { appearance, toggleAppearance: () => setAppearance(appearance === 'dark' ? 'light' : 'dark') };
}
